var _path, _g, _path2, _path3, _path4, _path5, _path6, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmpty = function SvgEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 375,
    height: 312,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#D2D8DF",
    strokeLinecap: "round",
    strokeWidth: 2.921,
    d: "M14.473 143.6v3.151"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#D2D8DF",
    strokeLinecap: "round",
    strokeWidth: 2.921
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.396 145.307 2.575 2.65M4.384 152.364h3.641M7.1 159.546l2.575-2.651"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D2D8DF",
    strokeLinecap: "round",
    strokeWidth: 2.921,
    d: "M14.473 160.408v-3.151M19.726 158.306l-2.101-2.101M23.927 153.054h-3.151M21.826 145.701l-2.1 2.1M183.587 6v2.1M177.284 12.302h2.101M183.587 18.605v-2.1M188.838 12.302h-2.101M61.742 94.233v3.152M52.29 103.688h3.15M61.742 112.089v-3.151M70.144 103.688h-3.15M287.842 208.765a4.548 4.548 0 0 1 0 9.095 4.547 4.547 0 0 1-4.546-4.548"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBECEE",
    fillRule: "evenodd",
    d: "M308.647 167.511c2.699-.842 6.837-4.143 7.795-7.695.868 3.14 4.509 6.853 7.794 7.134-3.698 1.309-7.233 5.199-7.794 8.255-.382-3.115-5.272-7.24-7.795-7.694M31.566 207.365c1.35-.421 3.418-2.071 3.897-3.847.434 1.569 2.254 3.426 3.897 3.567-1.849.654-3.616 2.599-3.897 4.127-.191-1.557-2.636-3.62-3.897-3.847",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D1D8DF",
    fillRule: "evenodd",
    d: "M56.62 61.247a3.525 3.525 0 1 1-7.05.001 3.525 3.525 0 0 1 7.05-.001",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBECEE",
    fillRule: "evenodd",
    d: "M292.006 70.714a5.892 5.892 0 1 1-11.784 0 5.892 5.892 0 1 1 11.784 0M373.616 54.749a4.673 4.673 0 1 1-9.346 0 4.674 4.674 0 1 1 9.346 0",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D2D8DF",
    strokeLinecap: "round",
    strokeWidth: 2.921,
    d: "M122.499 273.079a2.946 2.946 0 1 1-5.893.001 2.946 2.946 0 0 1 5.893-.001ZM120.747 38.596a3.526 3.526 0 1 1-7.051 0 3.526 3.526 0 0 1 7.051 0ZM210.664 305.713a4.36 4.36 0 0 1-5.63-2.527 4.363 4.363 0 1 1 8.156-3.104 4.364 4.364 0 0 1-2.526 5.631Z",
    clipRule: "evenodd"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E0E2EE",
    d: "M209.319 222.379h-86.136c-6.063 0-11.026-4.977-11.026-11.06V88.484c0-6.083 4.963-11.058 11.026-11.058h86.136c6.065 0 11.028 4.975 11.028 11.058v122.835c0 6.083-4.963 11.06-11.028 11.06"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8EBF2",
    d: "M201.966 227.632h-86.137c-6.063 0-11.025-4.977-11.025-11.06V93.737c0-6.084 4.962-11.058 11.025-11.058h86.137c6.065 0 11.028 4.974 11.028 11.058v122.835c0 6.083-4.963 11.06-11.028 11.06"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8DBEA",
    d: "M194.815 231.778H108.5c-6.075 0-11.048-4.957-11.048-11.015V98.437c0-6.058 4.973-11.012 11.048-11.012h86.315c6.077 0 11.05 4.954 11.05 11.012v122.326c0 6.058-4.973 11.015-11.05 11.015"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F2F7",
    d: "M194.815 231.778H108.5c-6.075 0-11.048-4.957-11.048-11.015V98.437c0-6.058 4.973-11.012 11.048-11.012h86.315c6.077 0 11.05 4.954 11.05 11.012v122.326c0 6.058-4.973 11.015-11.05 11.015"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0E2EE",
    d: "M182.373 124.694h-63.754c-1.821 0-3.311-1.418-3.311-3.15 0-1.735 1.49-3.152 3.311-3.152h63.754c1.821 0 3.311 1.417 3.311 3.152 0 1.732-1.49 3.15-3.311 3.15M182.373 143.599h-63.754c-1.821 0-3.311-1.418-3.311-3.15 0-1.734 1.49-3.152 3.311-3.152h63.754c1.821 0 3.311 1.418 3.311 3.152 0 1.732-1.49 3.15-3.311 3.15M182.373 162.507h-63.754c-1.821 0-3.311-1.417-3.311-3.15s1.49-3.152 3.311-3.152h63.754c1.821 0 3.311 1.42 3.311 3.152s-1.49 3.15-3.311 3.15M182.373 181.416h-63.754c-1.821 0-3.311-1.418-3.311-3.15 0-1.735 1.49-3.153 3.311-3.153h63.754c1.821 0 3.311 1.418 3.311 3.153 0 1.732-1.49 3.15-3.311 3.15M151.898 200.321h-33.265c-1.828 0-3.325-1.418-3.325-3.15 0-1.735 1.497-3.152 3.325-3.152h33.265c1.828 0 3.325 1.417 3.325 3.152 0 1.732-1.497 3.15-3.325 3.15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.1,
    d: "M219.04 175.885c-12.748 12.746-32.484 14.184-46.812 4.344a39 39 0 0 1-5.2-4.344 35.407 35.407 0 0 1-6.223-8.333 35.1 35.1 0 0 1-3.854-10.635c-2.251-11.583 1.114-24.051 10.077-33.01 8.985-8.986 21.455-12.329 33.04-10.1a36.3 36.3 0 0 1 10.637 3.854 37 37 0 0 1 5.712 3.878c.904.74 1.765 1.531 2.599 2.368a36.7 36.7 0 0 1 4.344 5.198c9.845 14.323 8.404 34.058-4.32 46.78"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0E2EE",
    d: "M215.473 173.376c-13.263 13.265-34.757 13.263-48.022 0-13.248-13.248-13.248-34.744.017-48.007 13.248-13.248 34.742-13.248 47.99 0 13.263 13.263 13.263 34.759.015 48.007m6.805-54.821c-17.024-17.024-44.61-17.024-61.634 0-17.022 17.021-17.037 44.625-.015 61.649 15.494 15.489 39.778 16.886 56.859 4.169a44 44 0 0 0 4.808-4.169 44 44 0 0 0 4.166-4.807c12.717-17.084 11.308-41.351-4.184-56.842"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#empty_svg__a)",
    d: "m289.276 244.377-.715.715c-4.728 4.73-12.471 4.73-17.202 0l-43.659-43.66 17.916-17.916 43.66 43.659c4.73 4.731 4.73 12.471 0 17.202"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0E2EE",
    d: "m227.404 174.063 12.901 12.901-9.159 9.157-12.899-12.901a45.5 45.5 0 0 0 4.906-4.254 45 45 0 0 0 4.251-4.903"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0166EB",
    d: "m288.623 226.637-17.803 17.8-3.205-3.207 17.801-17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#empty_svg__b)",
    d: "m246.607 184.131-18.29 18.29-2.718-2.717 18.29-18.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.5,
    d: "m206.692 120.806-44.855 44.853a31.5 31.5 0 0 1-3.462-9.561l38.756-38.757a32.7 32.7 0 0 1 9.561 3.465M221.399 131.467l-48.494 45.746a36 36 0 0 1-4.931-3.884 32 32 0 0 1-2.246-2.328l49.084-46.308c.86.665 1.676 1.373 2.467 2.122a33.5 33.5 0 0 1 4.12 4.652"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty_svg__a",
    x1: 260.262,
    x2: 260.262,
    y1: 183.516,
    y2: 248.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1177FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#4394FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#1D77EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty_svg__b",
    x1: 236.103,
    x2: 236.103,
    y1: 181.414,
    y2: 202.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1177FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#4394FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#1D77EE"
  })))));
};
export default SvgEmpty;